import React from "react";

interface AppTitleProps {
  text?: string | null;
  className?: string;
  level?: 1 | 2 | 3;
}

const AppTitle: React.FC<AppTitleProps> = ({ text, className, level = 1 }) => {
  if (text == null) return null;

  switch (level) {
    case 2:
      return (
        <h2
          className={`${className} text-xl font-semibold text-gray-900 dark:text-gray-100 select-none`}
        >
          {text}
        </h2>
      );
    case 3:
      return (
        <h3
          className={`${className} text-lg font-semibold text-gray-900 dark:text-gray-100 select-none`}
        >
          {text}
        </h3>
      );
    default:
      return (
        <h1
          className={`${className} text-2xl font-semibold text-gray-900 dark:text-gray-100 select-none`}
        >
          {text}
        </h1>
      );
  }
};

export default AppTitle;
